import { render, staticRenderFns } from "./DonationsAdd.vue?vue&type=template&id=01f7ed81"
import script from "./DonationsAdd.vue?vue&type=script&lang=js"
export * from "./DonationsAdd.vue?vue&type=script&lang=js"
import style0 from "./DonationsAdd.vue?vue&type=style&index=0&id=01f7ed81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports